<template>
  <div class="CommonStyleSet">
    <!-- 循环字段 进行字段的样式设置 addFieldSet -->
    <el-form style="background-color: white;" label-width="120px" label-suffix=":">
      <el-row  type="flex" style="flex-wrap:wrap;" >
        <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8"  >
          <el-form-item label="宽度设置">
            <el-input type="text" v-model="value.width" placeholder="200rpx" style="width:200px;" @blur="createStyleCode" ><template slot="prepend">width</template></el-input>
            <el-input type="text" v-model="value.minWidth" placeholder="200rpx" style="width:200px;" @blur="createStyleCode" ><template slot="prepend">min-width</template></el-input>
            <el-input type="text" v-model="value.maxWidth" placeholder="200rpx" style="width:200px;" @blur="createStyleCode" ><template slot="prepend">max-width</template></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8"  >
          <el-form-item label="高度设置">
            <el-input type="text" v-model="value.height" placeholder="200rpx" style="width:200px;" @blur="createStyleCode" ><template slot="prepend">height</template></el-input>
            <el-input type="text" v-model="value.minHeight" placeholder="200rpx" style="width:200px;" @blur="createStyleCode" ><template slot="prepend">min-height</template></el-input>
            <el-input type="text" v-model="value.maxHeight" placeholder="200rpx" style="width:200px;" @blur="createStyleCode" ><template slot="prepend">max-height</template></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8"  >
          <el-form-item label="行高设置">
            <el-input type="text" v-model="value.lineHeight" placeholder="200rpx" @blur="createStyleCode" ><template slot="prepend">line-height</template></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8"  >
          <el-form-item label="字体颜色设置">
            <el-input type="text" v-model="value.color" placeholder="#666" @blur="createStyleCode" ><template slot="prepend">color</template></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8"  >
          <el-form-item label="字体大小设置">
            <el-input type="text" v-model="value.fontSize" placeholder="18px" @blur="createStyleCode" ><template slot="prepend">font-size</template></el-input>
            <el-input type="text" v-model="value.fontFamily" placeholder="PingFang SC" @blur="createStyleCode" ><template slot="prepend">font-family</template></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8"  >
          <el-form-item label="字体加粗设置">
            <el-input type="text" v-model="value.fontWeight" placeholder="bold" @blur="createStyleCode" ><template slot="prepend">font-weight</template></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8"  >
          <el-form-item label="字体缩进设置">
            <el-input type="text" v-model="value.textIndent" placeholder="2" @blur="createStyleCode" ><template slot="prepend">text-indent</template></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8"  >
          <el-form-item label="水平对齐方式">
            <el-input type="text" v-model="value.textAlign" placeholder="center" @blur="createStyleCode" ><template slot="prepend">text-align</template></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8"  >
          <el-form-item label="垂直对齐方式">
            <el-input type="text" v-model="value.verticalAlign" placeholder="top" @blur="createStyleCode" ><template slot="prepend">vertical-align</template></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8"  >
          <el-form-item label="透明度设置">
            <el-input type="text" v-model="value.opacity" placeholder="1" @blur="createStyleCode" ><template slot="prepend">opacity</template></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8"  >
          <el-form-item label="字体其他设置">
            <el-input type="text" v-model="value.textDecoration" placeholder="1" @blur="createStyleCode" ><template slot="prepend">text-decoration</template></el-input>
            <el-input type="text" v-model="value.cursor" placeholder="pointer" @blur="createStyleCode" ><template slot="prepend">cursor</template></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8"  >
          <el-form-item label="背景颜色设置">
            <el-input type="text" v-model="value.backgroundColor" placeholder="#8BCFFF" style="width:250px;" @blur="createStyleCode" ><template slot="prepend">background-color</template></el-input>
            <el-input type="text" v-model="value.background" placeholder="#8BCFFF" style="width:250px;" @blur="createStyleCode" ><template slot="prepend">background</template></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8"  >
          <el-form-item label="内边距设置">
            <el-input type="text" v-model="value.padding" placeholder="10rpx 0" @blur="createStyleCode" ><template slot="prepend">padding</template></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8"  >
          <el-form-item label="外边距设置">
            <el-input type="text" v-model="value.margin" placeholder="0 10rpx 0 0" @blur="createStyleCode" ><template slot="prepend">margin</template></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8"  >
          <el-form-item label="阴影设置">
            <el-input type="text" v-model="value.boxShadow" placeholder="1px 1px 1px #fff" @blur="createStyleCode" ><template slot="prepend">box-shadow</template></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8"  >
          <el-form-item label="层级设置">
            <el-input type="text" v-model="value.zIndex" placeholder="1" @blur="createStyleCode"><template slot="prepend">z-index</template></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8"  >
          <el-form-item label="检索弹性盒模型">
            <el-input type="text" v-model="value.flex" placeholder="1" @blur="createStyleCode"><template slot="prepend">flex</template></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8"  >
          <el-form-item label="盒模型组成模式">
            <el-input type="text" v-model="value.boxSizing" placeholder="border-box" @blur="createStyleCode"><template slot="prepend">box-sizing</template></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24"  >
          <el-form-item label="定位设置">
            <el-input type="text" v-model="value.position" style="width:200px;" placeholder="fixed" @blur="createStyleCode" ><template slot="prepend">position</template></el-input>
            <el-input type="text" v-model="value.top" style="width:200px;" placeholder="10px" @blur="createStyleCode" ><template slot="prepend">top</template></el-input>
            <el-input type="text" v-model="value.left" style="width:200px;" placeholder="10px" @blur="createStyleCode" ><template slot="prepend">left</template></el-input>
            <el-input type="text" v-model="value.right" style="width:200px;" placeholder="10px" @blur="createStyleCode" ><template slot="prepend">right</template></el-input>
            <el-input type="text" v-model="value.bottom" style="width:200px;" placeholder="10px" @blur="createStyleCode" ><template slot="prepend">bottom</template></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8"  >
          <el-form-item label="边框设置">
            <el-input type="text" v-model="value.border" placeholder="2px solid #fff" @blur="createStyleCode" ><template slot="prepend">border</template></el-input>
            <el-input type="text" v-model="value.borderLeft" placeholder="2px solid #fff" @blur="createStyleCode" ><template slot="prepend">border-left</template></el-input>
            <el-input type="text" v-model="value.borderTop" placeholder="2px solid #fff" @blur="createStyleCode" ><template slot="prepend">border-top</template></el-input>
            <el-input type="text" v-model="value.borderRight" placeholder="2px solid #fff" @blur="createStyleCode" ><template slot="prepend">border-right</template></el-input>
            <el-input type="text" v-model="value.borderBottom" placeholder="2px solid #fff" @blur="createStyleCode" ><template slot="prepend">border-bottom</template></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8"  >
          <el-form-item label="圆角设置">
            <el-input type="text" v-model="value.borderRadius" placeholder="1px" @blur="createStyleCode" ><template slot="prepend">border-radius</template></el-input>
            <el-input type="text" v-model="value.borderTopLeftRadius" placeholder="1px" @blur="createStyleCode" ><template slot="prepend">border-top-left-radius</template></el-input>
            <el-input type="text" v-model="value.borderTopRightRadius" placeholder="1px" @blur="createStyleCode" ><template slot="prepend">border-top-right-radius</template></el-input>
            <el-input type="text" v-model="value.borderBottomLeftRadius" placeholder="1px" @blur="createStyleCode" ><template slot="prepend">border-bottom-left-radius</template></el-input>
            <el-input type="text" v-model="value.borderBottomRightRadius" placeholder="1px" @blur="createStyleCode" ><template slot="prepend">border-bottom-right-radius</template></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8"  >
          <el-form-item label="自定义样式js">
            <el-input type="textarea" v-model="value.zdyJs" placeholder="1px" @blur="createStyleCode" ><template slot="prepend">border-radius</template></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row  type="flex" style="flex-wrap:wrap;" >
        <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8"  >
          <el-form-item label="元素类型">
            <el-input type="text" v-model="value.display" placeholder="fixed" @blur="createStyleCode" ><template slot="prepend">display</template></el-input>
            <el-input type="text" v-model="value.overflow" placeholder="hidden" @blur="createStyleCode" ><template slot="prepend">overflow</template></el-input>
            <el-input type="text" v-model="value.whiteSpace" placeholder="nowrap" @blur="createStyleCode" ><template slot="prepend">white-space</template></el-input>
            <el-input type="text" v-model="value.wordBreak" placeholder="break-all" @blur="createStyleCode" ><template slot="prepend">word-break</template></el-input>
            <el-input type="text" v-model="value.textOverflow" placeholder="ellipsis" @blur="createStyleCode" ><template slot="prepend">text-overflow</template></el-input>
            <el-input type="text" v-model="value.WebkitBoxOrient" placeholder="vertical" @blur="createStyleCode" ><template slot="prepend">-webkit-box-orient</template></el-input>
            <el-input type="text" v-model="value.WebkitLineClamp" placeholder="2" @blur="createStyleCode" ><template slot="prepend">-webkit-line-clamp</template></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8"  >
          <el-form-item label="弹性布局">
            <el-input type="text" v-model="value.flexFlow" placeholder="<flex-direction>" @blur="createStyleCode" ><template slot="prepend">flex-flow</template></el-input>
            <el-input type="text" v-model="value.flexWrap" placeholder="nowrap" @blur="createStyleCode" ><template slot="prepend">flex-wrap</template></el-input>
            <el-input type="text" v-model="value.alignItems" placeholder="center" @blur="createStyleCode" ><template slot="prepend">align-items</template></el-input>
            <el-input type="text" v-model="value.flexDirection" placeholder="row" @blur="createStyleCode" ><template slot="prepend">flex-direction</template></el-input>
            <el-input type="text" v-model="value.alignContent" placeholder="center" @blur="createStyleCode" ><template slot="prepend">align-content</template></el-input>
            <el-input type="text" v-model="value.justifyContent" placeholder="center" @blur="createStyleCode" ><template slot="prepend">justify-content</template></el-input>
            <el-input type="text" v-model="value.float" placeholder="left" @blur="createStyleCode" ><template slot="prepend">float</template></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row  type="flex" style="flex-wrap:wrap;" >
        <el-col :xs="24" :sm="24" :md="18" :lg="18" :xl="18"  >
          <el-form-item label="背景图片设置">
            <el-select v-model="value.backgroundImage" clearable @change="createStyleCode">
              <el-option label="请选择" value="0" ></el-option>
              <el-option v-for="(one,index) in ImageList" v-if="one.TYPE==ImageType || !ImageType" :key="'image_common_'+index"
                  :label="one.NAME" :value="one.BG_URL"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8"  >
          <el-form-item label="背景图片样式">
            <el-input type="text" v-model="value.backgroundSize" placeholder="auto" @blur="createStyleCode" ><template slot="prepend">background-size</template></el-input>
            <el-input type="text" v-model="value.backgroundColor" placeholder="#ffffff" @blur="createStyleCode" ><template slot="prepend">background-color</template></el-input>
            <el-input type="text" v-model="value.backgroundRepeat" placeholder="no-repeat" @blur="createStyleCode" ><template slot="prepend">background-repeat</template></el-input>
            <el-input type="text" v-model="value.backgroudPosition" placeholder="top" @blur="createStyleCode" ><template slot="prepend">backgroud-position</template></el-input>
          </el-form-item>
        </el-col>
      </el-row>


      <div class="yl">
        <span>鼠标经过按钮预览效果：</span> <a href="#" :class="value.defineHover">{{value.defineHover}}</a>
      </div>

      <el-row  type="flex" style="flex-wrap:wrap;" >
        <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8"  >
          <el-form-item label="阴影和过渡效果设置" label-width="148">
            <el-select v-model="value.defineHover" clearable @change="createStyleCode">
              <el-option label="请选择" value=" " ></el-option>
              <el-option v-for="(item,index) in hoverShadow" :key="index" :label="item" :value="item"> {{item}} </el-option>
            </el-select>
          </el-form-item>
          
        </el-col>

        <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
          <el-form-item label="2D过渡效果设置" label-width="148">
            <el-select v-model="value.defineHover" clearable @change="createStyleCode">
              <el-option label="请选择" value=" " ></el-option>
              <el-option v-for="(item,index) in hover2D" :key="index" :label="item" :value="item"> {{item}} </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        
        <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
          <el-form-item label="背景色过渡效果设置" label-width="148">
            <el-select v-model="value.defineHover" clearable @change="createStyleCode">
              <el-option label="请选择" value=" " ></el-option>
              <el-option v-for="(item,index) in hoverBgc" :key="index" :label="item" :value="item"> {{item}} </el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
          <el-form-item label="边框过渡效果设置" label-width="148">
            <el-select v-model="value.defineHover" clearable @change="createStyleCode">
              <el-option label="请选择" value=" " ></el-option>
              <el-option v-for="(item,index) in hoverBorder" :key="index" :label="item" :value="item"> {{item}} </el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
          <el-form-item label="箭头过渡效果设置" label-width="148">
            <el-select v-model="value.defineHover" clearable @change="createStyleCode">
              <el-option label="请选择" value=" " ></el-option>
              <el-option v-for="(item,index) in hoverArrow" :key="index" :label="item" :value="item"> {{item}} </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
  import pageUtils from '@/js/page/pageUtil.js';
  import utils from '@/js/utils/util.js';
export default {
  name: 'CommonStyleSet',
  props: {
    value: {
      type:Object,
      default(){
        return {}
      }
    },
    ImageList:{
      type:Array
    },
    ImageType:{

    }
  },
  data() {
    return {
      fieldName:"",
      hoverShadow: ['hvr-shadow','hvr-grow-shadow','hvr-float-shadow','hvr-glow','hvr-shadow-radial','hvr-box-shadow-outset','hvr-box-shadow-inset'],
      hover2D: ['hvr-grow','hvr-shrink','hvr-pulse','hvr-pulse','hvr-pulse-grow','hvr-pulse-shrink','hvr-push','hvr-pop','hvr-bounce-in','hvr-bounce-out','hvr-rotate','hvr-grow-rotate','hvr-float','hvr-sink','hvr-bob','hvr-hang','hvr-skew','hvr-skew-forward','hvr-skew-backward','hvr-wobble-horizontal','hvr-wobble-vertical','hvr-wobble-to-bottom-right','hvr-wobble-to-top-right','hvr-wobble-top','hvr-wobble-bottom','hvr-wobble-skew','hvr-buzz','hvr-buzz-out','hvr-forward','hvr-backward'],
      hoverBgc: ['hvr-fade','hvr-back-pulse','hvr-sweep-to-right','hvr-sweep-to-left','hvr-sweep-to-bottom','hvr-sweep-to-top','hvr-bounce-to-right','hvr-bounce-to-left','hvr-bounce-to-bottom','hvr-bounce-to-top','hvr-radial-out','hvr-radial-in','hvr-rectangle-in','hvr-rectangle-out','hvr-shutter-in-horizontal','hvr-shutter-out-horizontal','hvr-shutter-in-vertical','hvr-shutter-out-vertical'],
      hoverBorder: ['hvr-border-fade','hvr-hollow','hvr-trim','hvr-ripple-out','hvr-ripple-in','hvr-outline-out','hvr-outline-in','hvr-round-corners','hvr-underline-from-left','hvr-underline-from-center','hvr-underline-from-right','hvr-reveal','hvr-underline-reveal','hvr-overline-reveal','hvr-overline-from-left','hvr-overline-from-center','hvr-overline-from-right'],
      hoverArrow: ['hvr-bubble-top','hvr-bubble-right','hvr-bubble-bottom','hvr-bubble-left','hvr-bubble-float-top','hvr-bubble-float-right','hvr-bubble-float-bottom','hvr-bubble-float-left'],
    };
  },
  created() {
    console.log("this.value=================",this.value);
  },
  mounted() {
  },
  watch:{
  },
  computed:{
  },
  components: {
  },
  methods: {
    /**
     * 生成style代码 GLOBAL.fileServeUrl
     */
    createStyleCode:function(){
      var that = this;
      var styleSet = this.value;
      var styleSetCode = "";
      console.log("styleSet==========================",styleSet);
      for (var key in styleSet) {
        if(key != "styleSetCode" && key != "ImageType" && key != "zdyJs") {

          var value = styleSet[key];
          if(key == "backgroundImage" ){
            if(value && value != '0') {
              value = "url('"+this.GLOBAL.getFileServeUrl()+value+"')"
            } else {
              value = "";
            }
          }
          if(value && value.trim().length > 0) {
            styleSetCode+=that.underline(key) + ":" + value + ";"
          }
        }
      }
      console.log("styleSetCode==========================",styleSetCode);
      this.value.styleSetCode = styleSetCode;
      this.$forceUpdate();
    },
    /**
     * 驼峰转为中划线
     */
    underline:function (str){
      return str.replace(/([A-Z])/g, '-$1').toLowerCase()
    }
  }
}
        
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .el-col{min-height: 41px;padding: 3px}
</style>
